import { Node_Type } from 'ricos-schema';
import { LINK_TYPE } from '../../../consts.js';
import { m as mergeTextNodes } from '../../../convertDecorationDataToDraft-d7b95492.js';
import 'lodash';
import '../../nodeUtils.js';
import '../../../ReadonlyNonEmptyArray-0e481d0b.js';
import '../../../string-40bcd6bf.js';
import 'uuid';
import '../../../utils.js';
import '../../generateRandomId.js';
import '../../draft/consts.js';
import '../../draft/toDraft/convertContainerData.js';
import '../../../index-71a2067e.js';
import '../../../index-205daf5f.js';
import '../../draft/toDraft/convertDraftPluginDataNoInnerRCE.js';
import '../../draft/toDraft/convertStructToJson.js';
import '../../../Either-f9cb4a7c.js';
import '../../../Record-8960daac.js';
import '../../../ReadonlyRecord-86a56753.js';
import '../../../Tuple-2f69c1c7.js';
import '../../../fp-utils-75447caf.js';
import '../../draft/struct-refined-types.js';
import '../../draft/toDraft/utils.js';
import '../../draft/emojiRegex.js';
import '../../draft/toDraft/preprocess.js';
import '../../draft/toDraft/utils/parseDocStyle.js';
import '../../../version/versioningUtils.js';
import '../../../package-b069657d.js';

const parseTextNodes = (node, addTextLinks) => {
  const {
    text,
    decorationMap: { [LINK_TYPE]: linkDecorations }
  } = mergeTextNodes(node.nodes);
  const finalText = addTextLinks ? addLinksToText(text, linkDecorations) : text;
  return removeTrailingNewLine(finalText);
};
const listNodeToLines = (listNode, addTextLinks, depth = 0) => listNode.nodes.flatMap((listItemNode, listItemIndex) => {
  return listItemNode.nodes.flatMap((listItemNodeChild, index) => {
    if (listItemNodeChild.type === Node_Type.PARAGRAPH || listItemNodeChild.type === Node_Type.HEADING) {
      const text = parseTextNodes(listItemNodeChild, addTextLinks);
      if (index === 0) {
        if (listNode.type === Node_Type.ORDERED_LIST) {
          return "   ".repeat(depth) + (listItemIndex + 1) + ". " + text;
        }
        if (listNode.type === Node_Type.BULLETED_LIST) {
          return "   ".repeat(depth) + " \u2022 " + text;
        }
      }
      return "   ".repeat(depth + 1) + text;
    }
    if (listItemNodeChild.type === Node_Type.ORDERED_LIST || listItemNodeChild.type === Node_Type.BULLETED_LIST) {
      return listNodeToLines(listItemNodeChild, addTextLinks, depth + 1);
    }
    return [];
  });
});
const parseListNode = (node, delimiter, addTextLinks) => listNodeToLines(node, addTextLinks).join(delimiter);
const addLinksToText = (text, linkDecorations = []) => linkDecorations.sort((a, b) => a.end - b.end).reduce(
  (newText, link) => {
    var _a, _b;
    return insertInText(
      newText,
      link.end + newText.length - text.length + 1,
      `(${(_b = (_a = link.linkData) == null ? void 0 : _a.link) == null ? void 0 : _b.url})`
    );
  },
  text
);
const insertInText = (text, pos, insertedText) => text.substring(0, pos) + insertedText + text.substring(pos);
const removeTrailingNewLine = (text) => text.endsWith("\n") ? text.substring(0, text.length - 1) : text;
function* parseImage({ imageData }, delimiter) {
  const { caption } = imageData || {};
  const { src } = (imageData == null ? void 0 : imageData.image) || {};
  const id = (src == null ? void 0 : src.id) || (src == null ? void 0 : src.custom);
  const url = yield {
    command: "getImageUrl",
    data: `https://static.wixstatic.com/media/${id == null ? void 0 : id.replace("media/", "")}`
  };
  return [caption, url].filter(Boolean).join(delimiter);
}
const getDefaultVideoUrl = (fileId) => `https://video.wixstatic.com/${fileId}`;
const getDefaultAudioUrl = (fileId) => `https://static.wixstatic.com/${fileId}`;
function* parseVideo({ videoData }, delimiter) {
  const { video, title } = videoData || {};
  const { custom, id, url } = (video == null ? void 0 : video.src) || {};
  const vidId = id || custom;
  const vidUrl = url || "";
  let videoUrl;
  if (vidId) {
    videoUrl = yield {
      command: "getVideoUrl",
      data: vidId
    };
  } else {
    videoUrl = yield {
      command: "getVideoEmbeddedUrl",
      data: vidUrl
    };
  }
  return title ? title + delimiter + videoUrl : videoUrl;
}
function* parseAudio({ audioData }, delimiter) {
  const { audio, name } = audioData || {};
  const { id, url } = (audio == null ? void 0 : audio.src) || {};
  let audioUrl = url || "";
  if (id) {
    audioUrl = yield {
      command: "getAudioUrl",
      data: id
    };
  }
  return name ? name + delimiter + audioUrl : audioUrl;
}
function* parseGiphy({ gifData }) {
  var _a;
  let gifUrl = ((_a = gifData == null ? void 0 : gifData.original) == null ? void 0 : _a.gif) || "";
  if (gifUrl) {
    gifUrl = yield {
      command: "getGifUrl",
      data: gifUrl
    };
  }
  return gifUrl;
}
const parseMap = ({ mapData }) => {
  const { address } = (mapData == null ? void 0 : mapData.mapSettings) || {};
  return address || "";
};
const parseAppEmbed = ({ appEmbedData }, delimiter) => {
  const { url, name } = appEmbedData || {};
  return [name, url].filter(Boolean).join(delimiter);
};
const parseLinkPreview = ({ linkPreviewData }) => {
  const { url } = (linkPreviewData == null ? void 0 : linkPreviewData.link) || {};
  return url || "";
};
const parseEmbed = ({ embedData }, delimiter) => {
  var _a;
  return [(_a = embedData == null ? void 0 : embedData.oembed) == null ? void 0 : _a.title, embedData == null ? void 0 : embedData.src].filter(Boolean).join(delimiter);
};

export { addLinksToText, getDefaultAudioUrl, getDefaultVideoUrl, parseAppEmbed, parseAudio, parseEmbed, parseGiphy, parseImage, parseLinkPreview, parseListNode, parseMap, parseTextNodes, parseVideo };
//# sourceMappingURL=convertNodes.js.map
